
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_1lhle_99",
  "marker": "awsui_marker_10ipo_1lhle_150",
  "marker--line": "awsui_marker--line_10ipo_1lhle_193",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_1lhle_197",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_1lhle_204",
  "marker--dashed": "awsui_marker--dashed_10ipo_1lhle_220",
  "root": "awsui_root_10ipo_1lhle_243",
  "value": "awsui_value_10ipo_1lhle_278",
  "expandable": "awsui_expandable_10ipo_1lhle_282",
  "list-item": "awsui_list-item_10ipo_1lhle_286",
  "inner-list-item": "awsui_inner-list-item_10ipo_1lhle_287",
  "key-value-pair": "awsui_key-value-pair_10ipo_1lhle_292",
  "expandable-section": "awsui_expandable-section_10ipo_1lhle_293",
  "key": "awsui_key_10ipo_1lhle_292",
  "sub-items": "awsui_sub-items_10ipo_1lhle_306",
  "list": "awsui_list_10ipo_1lhle_286",
  "compact": "awsui_compact_10ipo_1lhle_332",
  "with-sub-items": "awsui_with-sub-items_10ipo_1lhle_337",
  "full-width": "awsui_full-width_10ipo_1lhle_342",
  "announced": "awsui_announced_10ipo_1lhle_346"
};
  